import axiosInstance from "@/api/axiosInstance";
import { MarkPreEpWelcomeSeenResponse } from "./types";

/** Records that the user finished or skipped the Pre-EP welcome intro. */
export const markPreEpWelcomeSeen =
  async (): Promise<MarkPreEpWelcomeSeenResponse> => {
    const response = await axiosInstance.post<MarkPreEpWelcomeSeenResponse>(
      "/api/private/pre-ep-welcome/seen",
    );

    return response.data;
  };
